<app-loader *ngIf="!isLoaded; else loadedContainer"></app-loader>
<ng-template #loadedContainer>
  <div *ngIf="restrictions.length">
    <ng-container *ngFor="let restriction of restrictions">
      <ng-container *ngIf="Object.keys(restriction).toString() === panelLanguage && Object.values(restriction).length">
        <div class="terms-container">
          <nb-icon class="warning-icon" icon="warning" pack="icomoon"></nb-icon>
          <h1>{{ 'view_translations.terms_of_promotion' | translate}}</h1>
          <div class="restrictions-container">
            <div class="restriction" *ngFor="let value of Object.values(restriction)">
              <h5 class="info smaller" [innerHTML]="value | sanitizeHtml"></h5>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div *ngIf="!restrictions.length" class="terms-container">
    <nb-icon class="warning-icon" icon="warning" pack="icomoon"></nb-icon>
    <h1>{{ 'view_translations.terms_of_promotion' | translate}}</h1>
    <p class="mb-0 p-0 no-restrictions">{{ 'view_translations.no_restrictions_program' | translate }}</p>
  </div>
</ng-template>
